import { PoStatusEnum } from '@shahi-analytics/shared-models';
import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';
import { CommonFieldsModel } from './common-fields.model';

@Entity('m_po_header')
export class PoHeaderEntity extends CommonFieldsModel {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: number;

    @Column('mediumint', {
        nullable: false,
        name: 'buyer_id'
    })
    buyerId: number;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'po_number'
    })
    poNumber: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'po_description'
    })
    poDescription: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'po_id'
    })
    poId: string;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'po_name'
    })
    poName: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'po_status'
    })
    poStatus: PoStatusEnum;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'product_id'
    })
    productId: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'product_type'
    })
    productType: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'productDesc'
    })
    productDesc: string;

    @Column('varchar', {
        nullable: true,
        length: 30,
        name: 'style'
    })
    style: string;
    
}


